import Rete from "rete";
import AnyTypeSocket, { BooleanSocket } from "../../../Utils/CommonSockets.js";
import { ComparisonControl } from "../../rete-controls/ComparisonControl.js";

export default class ComparisonComponent extends Rete.Component {
  constructor() {
    super("Comparison"); // name
    this._categories = ["Conditionals", "Simulator", "tryMe"];
  }

  builder(node) {
    var inp1 = new Rete.Input("in1", "A", AnyTypeSocket);
    var inp2 = new Rete.Input("in2", "B", AnyTypeSocket);

    var out1 = new Rete.Output("out1", "A", AnyTypeSocket);
    var out2 = new Rete.Output("out2", "B", AnyTypeSocket);
    var out3 = new Rete.Output("out3", "Yes/No", BooleanSocket);

    var compareControl = new ComparisonControl(this.editor, "compare");

    return node
      .addInput(inp1)
      .addInput(inp2)
      .addOutput(out1)
      .addOutput(out2)
      .addOutput(out3)
      .addControl(compareControl);
  }

  worker(node, inputs, outputs) {
    var compControl = +node.data.compare;
    var compareValue;

    let a = inputs["in1"];
    let b = inputs["in2"];
    if ((a.length !== 0 && a[0] !== undefined) && (b.length !== 0 && b[0] !== undefined)) {
        a= a[0];
        b = b[0];
        switch (compControl) {

        case 0: //>=
        compareValue = (a >= b);
        break;
        case 1: //>=
        compareValue = (a > b);
        break;
        case 2: //>=
        compareValue = (a == b);
        break;
        case 3: //>=
        compareValue = (a != b);
        break;
        case 4: //>=
        compareValue = (a < b);
        break;
        case 5: //>=
        compareValue = (a <= b);
        break;
        default:
        compareValue = false;
            
        
      }
      outputs["out1"] = a;
      outputs["out2"] = b;
      outputs["out3"] = compareValue;


    }
  }
}

//ReteComponentStore.add(new NumberAdderComponent());
